export default "__VITE_ASSET__l9ViYkq___"